$(document).ready(function () {
    var ajaxPath = '/action/report/accountingInfo';
    var ajaxLockActive = false;

    $(document).on('click', 'div#accounting_tool_form_wrapper a#update_account_tool_result', function () {
        if (isNaN($('div#accounting_tool_form_wrapper input[name="account"]').val())) {
            alert('ugyldig konto');
            return;
        }

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: ajaxPath,
            data: {
                action: 'get_account_information',
                sync_code: $('div#accounting_tool_form_wrapper input[name="account_sync_code"]').val(),
                account_number: $('div#accounting_tool_form_wrapper input[name="account"]').val()
            },
            dataType: 'json'
        }).success(function (response) {
            $('div#accounting_tool_result_wrapper').html(response.html);
            ajaxLockActive = false;
        }).error(function (response) {
            alert('Kunne ikke hente rapport!');
            ajaxLockActive = false;
        });
        return false;
    });
});